import {CircularProgress, IconButton, MenuItem, TableCell, TableRow} from "@mui/material";
import Iconify from "../../../components/Iconify";
import MenuPopover from "../../../components/menu-popover";
import {useState} from "react";
import {handleCommentGroup} from "../../../helper/other";
import moment from "moment";

export default function CommentsListTableRow({loading, row, onDelete, onEdit}) {

    const {dateFrom, dateTo, comment, allowedViewers, operatorName, lineName, departureTime} = row;

    const [openPopover, setOpenPopover] = useState(null);

    const handleOpenPopover = (event) => {
        setOpenPopover(event.currentTarget);
    };

    const handleClosePopover = () => {
        setOpenPopover(null);
    };

    return (
        <>
            <TableRow hover>
                <TableCell align="left">{dateFrom}</TableCell>
                <TableCell align="left">{dateTo}</TableCell>
                <TableCell align="left">{comment?.slice(0, 25)}</TableCell>
                <TableCell align="left">{handleCommentGroup(allowedViewers)}</TableCell>
                <TableCell align="left">{lineName}</TableCell>
                <TableCell align="left">{moment.utc(departureTime, 'HH:mm').format('HH:mm')}</TableCell>
                <TableCell align="left">{operatorName}</TableCell>
                <TableCell align="center">
                    <IconButton color={openPopover ? 'primary' : 'default'} onClick={handleOpenPopover}>
                        {loading ? <CircularProgress size={20}/> :
                            <Iconify icon="eva:more-vertical-fill"/>
                        }
                    </IconButton>
                </TableCell>
            </TableRow>

            <MenuPopover open={openPopover} onClose={handleClosePopover} arrow="right-top" sx={{width: 140}}>
                <MenuItem
                    onClick={() => {
                        onDelete(row.id);
                        handleClosePopover();
                    }}>
                    <Iconify
                        sx={{color: "error.main"}}
                        icon="eva:trash-2-outline"/>
                    Obriši
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        onEdit(row);
                        handleClosePopover();
                    }}>
                    <Iconify icon="eva:edit-fill"/>
                    Izmeni
                </MenuItem>
            </MenuPopover>
        </>
    )
}
